import { faSatellite } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GENERIC_COMPONENTS } from 'components/AgentTemplateEditView/menu/genericComponents';
import A from 'components/general/A';
import StyledButton from 'components/general/StyledButton';
import ViewPortInlay from 'components/general/ViewPortInlay';
import { IComponent, ISubsystem } from 'components/general/types/power';
import EntitySegment from 'components/general/wizards/EntitySegment';
import { useActiveEntities } from 'hooks';
import { Link } from 'react-router-dom';
import Routes from 'routes';
import ComponentAccordion from './ComponentAccordion';
import guidance from './guidance';
import useStyles from './styles';

interface IProps {
  index: string;
  subsystem: ISubsystem;
  editable?: boolean;
  onActionClick?: () => void;
}

const LoadsSegment = (props: IProps) => {
  const { index, editable, subsystem, onActionClick } = props;
  const {
    branch: { id },
  } = useActiveEntities();
  const { classes } = useStyles();
  const components = subsystem.components;

  return (
    <>
      <EntitySegment
        title={subsystem.name}
        index={index}
        editable={editable}
        selectedData={subsystem}
        onActionClick={onActionClick}
        guidance={guidance}
      >
        <div className={classes.componentAccordionHeaderRow}>
          <h5>Components</h5>
          <div className={classes.componentAccordionManage}>
            <StyledButton
              component={Link}
              to={Routes.AGENT_TEMPLATE_EDIT(id, GENERIC_COMPONENTS, subsystem.id)}
              fullWidth
              framed
              borderless
            >
              <FontAwesomeIcon icon={faSatellite} />
              <span style={{ paddingLeft: 6 }}>Manage Components</span>
            </StyledButton>
          </div>
        </div>
        {/* This div wraps the Accordion elements to enable proper styling of first and last item */}
        <div>
          {components.map((c: IComponent) => (
            <ComponentAccordion component={c} key={c.name} />
          ))}
          {components.length === 0 && (
            <ViewPortInlay
              className={classes.noComponentInlay}
              text={
                <>
                  This subsystem currently has no components.
                  <br />
                  {'Add components in '}
                  <span>
                    <FontAwesomeIcon icon={faSatellite} />
                    <A
                      href={`#${Routes.AGENT_TEMPLATE_EDIT(id, GENERIC_COMPONENTS, subsystem.id)}`}
                    >
                      Generic Components
                    </A>
                  </span>
                </>
              }
            />
          )}
        </div>
      </EntitySegment>
    </>
  );
};
export default LoadsSegment;
